import React from 'react'

import { Group } from '@/core/api/entities/group'
import { useTranslation } from '@/core/i18n/useTranslation'
import ConfirmationModal from '@/shared/components/molecules/ConfirmationModal/ConfirmationModal'

interface DeleteGroupModalProps {
	visible: boolean
	group: Group | null
	onClose: () => void
	onConfirm: () => void
	isDeleting: boolean
}

const DeleteGroupModal: React.FC<DeleteGroupModalProps> = ({
	visible,
	group,
	onClose,
	onConfirm,
	isDeleting,
}) => {
	const { t } = useTranslation('common')

	return (
		<ConfirmationModal
			visible={visible}
			title={t('entities.group.delete.title')}
			description={t('entities.group.delete.description', {
				name: group?.name,
			})}
			confirmText={t('actions.delete')}
			cancelText={t('actions.cancel')}
			variant="destructive"
			onConfirm={onConfirm}
			onClose={onClose}
			isLoading={isDeleting}
			loadingText={t('actions.loading')}
		/>
	)
}

export default DeleteGroupModal
